
export default {
  name: 'BasketballIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
